export enum ActionTypes {
  SET_LOADING = '@app/global/SET_LOADING',

  TOGGLE_MENU = '@app/global/TOGGLE_MENU',
  RESET_STATE = '@app/global/RESET_STATE',

  PARTICIPANT_LOGIN_SUCCESS = '@app/global/PARTICIPANT_LOGIN_SUCCESS',
  PARTICIPANT_PAYMENT_SUCCESS = '@app/global/PARTICIPANT_PAYMENT_SUCCESS',
}
